
import Vue from 'vue'
import { EntityService } from '@/services/entity.service'
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'

const entityService = new EntityService()

export default Vue.extend({
  data: () => ({
    entity: 'projects',
    isLoading: false,
    search: '',
    form: {
      code: '',
      name: '',
      keywords: []
    }
  }),
  methods: {
    toggleModal (value: boolean) {
      this.$emit('input', value)
    },
    async save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.isLoading = true
        try {
          await entityService.createEntity(this.entity, this.form)
          this.$emit('input', false)
        } catch (e) {
          alert(e.message)
        }
        this.isLoading = false
      }
    },
    getError: function (element: string) {
      const obj = this.$v.form[element] || { $error: '' }
      if (obj.$error) return 'Campo inválido'
    }
  },
  mixins: [validationMixin],
  name: 'ProjectsNew',
  props: ['value'],
  validations: {
    form: {
      code: {
        required,
        maxLength: maxLength(150)
      },
      name: { required }
    }
  }
})
